import config from '../config';
export default {
    state:{
        popStack:[],

        menu:[],
        userinfo:null,
        jyjid:null,
        itemTitle:'',


        //教育局相关角色字典
        jyjRoleDic:[
            {key:'0',name:'普通成员'},
            {key:'8192',name:'主席|局长'},
            {key:'16384',name:'书记'},
            {key:'32768',name:'教育局管理员'},
        ],
        //老师相关角色字典
        teacherRoleDic:[
            {key:'16',name:'教师'},
            //{key:'32',name:'班主任'},
            {key:'64',name:'教务主任'},
            {key:'128',name:'学校管理员'},
            {key:'256',name:'校长'},
            // {key:'512',name:'校党委书记'},
            {key:'1024',name:'副校长'}
        ],
        //学校性质
        schoolModes:[
            {key:'1',name:'幼儿园',years:[1,2,3,4]},
            {key:'2',name:'小学',years:[5,6]},
            {key:'4',name:'初中',years:[2,3,4]},
            {key:'8',name:'职高',years:[3,4]},
            {key:'16',name:'高中',years:[3,4]},
            {key:'32',name:'大学',years:[3,4]}
        ],
    },
    mutations:{
        //修改菜单
        xMenu(state,val){
            state.menu = val;
        },
        //修改用户所在团队信息
        xUserInfo(state,val){
            state.userinfo = val;
        },
        //修改教育局id
        xJyjId(state,val){
            state.jyjid = val;
        },

        //修改当前栏目标题
        xItemTitle(state,val){
            state.itemTitle = val;
        },

        //右侧浮窗 esc记录
        xPopStack(state,val){
            state.popStack.push(val);
        },
        doPop(state,val){
            state.popStack.pop();
        }
    },
    actions:{
        //获取用户团队列表
        async getUserInfo({dispatch,commit,state},{self,cb}){
            let msg = await self.$get('/api/user/getuserinfo');
            if(msg.result===0 && msg.data && msg.data.user_info){
                commit('xUserInfo',msg.data.user_info);
                dispatch('getMenus',{self:self,cb:()=>{
                        cb(msg);
                    }});
            }else{
                cb({result:-1});
            }

        },

        //获取用户菜单
        async getMenus({dispatch,commit,state},{self,cb}){
            let msg = await self.$get('/api/leftmenu/getmenus');
            if(msg.result===0){
                if(msg.data && msg.data.left_menus){
                    msg.data.left_menus.forEach(item=>{
                        switch (item.menu_type){
                            case 1:item.icon = 'fa-cubes';
                                item.url="/class";break;
                            case 2:item.icon = 'fa-building-o';
                                item.url="/school/1";break;
                            case 3:item.icon = 'fa-flag-checkered';
                                item.url="/jyj";
                                //commit('xJyjId',item.zone_id);

                        }
                    });
                    commit('xMenu',msg.data.left_menus);
                    cb(msg);
                }
            }else{
                cb(msg);
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/System.js